import { useTypewriter } from "../hooks/useInView";
import profilePhoto from "../assets/profile.jpg";
import resume from "../assets/AKROSH_RM_G.pdf";
const TERMINAL_LINES = [
  { text: "const developer = {", color: "#4A90C4" },
  { text: "  name: 'Akrosh R M',", color: "#00D8FF" },
  { text: "  role: 'Full Stack Developer',", color: "#FF9900" },
  { text: "  exp: '3.3 years',", color: "#00D8FF" },
  { text: "  stack: ['React','Node','AWS','PostgreSQL'],", color: "#FFBD59" },
  { text: "  freelance: ['HRM App','CRM App'],", color: "#10B981" },
  { text: "  location: 'Gulbarga, India'", color: "#00D8FF" },
  { text: "};", color: "#4A90C4" },
];

const FLOAT_BADGES = [
  {
    label: "Lambda",
    icon: "λ",
    color: "#FF9900",
    style: { top: "18%", right: "4%", animationDelay: "0s" },
  },
  {
    label: "RDS",
    icon: "🗄",
    color: "#4A90C4",
    style: { top: "42%", right: "2%", animationDelay: ".4s" },
  },
  {
    label: "EventBridge",
    icon: "⚡",
    color: "#F59E0B",
    style: { top: "66%", right: "6%", animationDelay: ".8s" },
  },
  {
    label: "S3",
    icon: "🪣",
    color: "#10B981",
    style: { top: "24%", left: "2%", animationDelay: ".2s" },
  },
  {
    label: "CloudFront",
    icon: "☁",
    color: "#00D8FF",
    style: { top: "58%", left: "3%", animationDelay: ".6s" },
  },
  {
    label: "APIGateway",
    icon: "🪣",
    color: "#10B981",
    style: { top: "10%", left: "5%", animationDelay: ".2s" },
  },
  {
    label: "CloudWatch",
    icon: "☁",
    color: "#F59E0B",
    style: { top: "48%", left: "10%", animationDelay: ".6s" },
  },
];

function WAIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
  );
}

function LinkedInButton({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.024-3.037-1.85-3.037-1.852 0-2.136 1.445-2.136 2.939v5.667H9.353V9h3.414v1.561h.048c.476-.9 1.637-1.85 3.37-1.85 3.604 0 4.268 2.371 4.268 5.455v6.286zM5.337 7.433a2.063 2.063 0 11.001-4.127 2.063 2.063 0 01-.001 4.127zM7.114 20.452H3.56V9h3.554v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function DownLoadIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm-7 2v2h14v-2H5z" />
    </svg>
  );
}

export default function Hero() {
  const { displayed, currentLine, done } = useTypewriter(
    TERMINAL_LINES,
    44,
    400,
  );

  const openWA = () =>
    window.open(
      "https://wa.me/918310691450?text=Hi%20Akrosh!%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20connect.",
      "_blank",
    );

  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = resume;
    link.download = "Akrosh_RM_Resume.pdf";
    link.click();
  };

  return (
    <section
      id="hero"
      className="relative z-10 min-h-[91vh] flex items-center justify-center overflow-hidden px-5 sm:px-8 py-20 sm:py-24"
    >
      {/* Glow blobs */}
      <div
        className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[650px] rounded-full"
        style={{
          background:
            "radial-gradient(ellipse, rgba(255,153,0,.055) 0%, transparent 68%)",
        }}
      />
      <div
        className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[400px] rounded-full"
        style={{
          background:
            "radial-gradient(ellipse, rgba(0,216,255,.04) 0%, transparent 68%)",
        }}
      />

      {/* Floating AWS badges — hidden on small screens */}
      {FLOAT_BADGES.map((b) => (
        <div
          key={b.label}
          className="hidden lg:flex absolute items-center gap-1.5 bg-surf border border-bord2 rounded-xl px-3 py-2 pointer-events-none z-20 animate-float"
          style={{
            ...b.style,
            boxShadow: "0 4px 20px rgba(0,0,0,.45)",
            animationDelay: b.style.animationDelay,
          }}
        >
          <span className="text-xs">{b.icon}</span>
          <span
            className="font-mono text-[10px] font-medium"
            style={{ color: b.color }}
          >
            {b.label}
          </span>
        </div>
      ))}

      {/* Main content */}
      <div className="relative z-10 w-full max-w-4xl text-center animate-fade-up">
        {/* Label */}
        <div className="inline-flex items-center gap-2 bg-aws/[.13] border border-aws/25 rounded-full px-4 py-1.5 mb-7 font-mono text-[10px] text-aws tracking-[2px]">
          AWS SERVERLESS SPECIALIST &nbsp;·&nbsp; 3.3 YRS
        </div>

        {/* Name */}
        <h1
          className="font-display font-black leading-[1.02] tracking-[-2px] mb-2"
          style={{ fontSize: "clamp(44px,9vw,90px)" }}
        >
          Akrosh{" "}
          <span className="bg-gradient-to-r from-aws to-aws2 bg-clip-text text-transparent">
            R M
          </span>
        </h1>

        {/* Sub row */}
        <div className="flex items-center justify-center gap-2.5 flex-wrap mb-10">
          {[
            "React.js",
            "·",
            "Node.js",
            "·",
            "AWS Serverless",
            "·",
            "PostgreSQL",
          ].map((item, i) =>
            item === "·" ? (
              <span key={i} className="text-tx3 text-base">
                ·
              </span>
            ) : (
              <span
                key={i}
                className="font-mono text-xs font-medium"
                style={{
                  color: ["#00D8FF", "#10B981", "#FF9900", "#4A90C4"][
                    Math.floor(i / 2)
                  ],
                }}
              >
                {item}
              </span>
            ),
          )}
        </div>

        {/* Photo + Terminal */}
        <div className="flex flex-col sm:flex-row gap-6 max-w-2xl mx-auto mb-9 text-left items-center sm:items-stretch">
          {/* Photo */}
          <div className="flex-shrink-0 relative">
            <div
              className="w-44 h-52 sm:w-48 sm:h-56 rounded-2xl overflow-hidden border-2 border-gray-400"
              style={{ boxShadow: "0 20px 50px rgba(0,0,0,.6)" }}
            >
              <img
                src={profilePhoto}
                alt="Akrosh R M"
                className="w-full h-full object-cover "
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.style.cssText +=
                    "background:linear-gradient(135deg,#FF9900,#FFBD59);display:flex;align-items:center;justify-content:center;";
                  const fb = document.createElement("span");
                  fb.textContent = "AR";
                  fb.style.cssText =
                    "font-family:'Syne',sans-serif;font-size:52px;font-weight:800;color:#000;letter-spacing:-2px";
                  e.target.parentNode.appendChild(fb);
                }}
              />
            </div>
            <div
              className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 bg-surf border border-bord2 rounded-lg px-3 py-1 font-mono text-[9px] text-aws whitespace-nowrap"
              style={{ boxShadow: "0 4px 16px rgba(0,0,0,.5)" }}
            >
              Full Stack Developer
            </div>
          </div>

          {/* Terminal */}
          <div
            className="flex-1 bg-bg2 border border-bord2 rounded-2xl p-5 relative overflow-hidden"
            style={{ boxShadow: "0 24px 60px rgba(0,0,0,.5)" }}
          >
            {/* Traffic lights */}
            <div className="flex gap-1.5 mb-4 items-center">
              {["#EF4444", "#F59E0B", "#10B981"].map((c) => (
                <div
                  key={c}
                  className="w-2.5 h-2.5 rounded-full opacity-85"
                  style={{ background: c }}
                />
              ))}
              <span className="font-mono text-[10px] text-tx3 ml-1.5">
                developer.js
              </span>
            </div>
            {/* Scan line */}
            <div
              className="absolute left-0 right-0 h-0.5 pointer-events-none"
              style={{
                background:
                  "linear-gradient(90deg,transparent,rgba(0,216,255,.065),transparent)",
                animation: "scan 3.5s linear infinite",
              }}
            />
            {/* Lines */}
            {TERMINAL_LINES.map((line, i) => (
              <div
                key={i}
                className="font-mono text-xs leading-[1.85] min-h-[21px]"
                style={{ color: line.color }}
              >
                {displayed[i] || ""}
                {i === currentLine && !done && (
                  <span
                    className="border-r-2 ml-px"
                    style={{ animation: "blink 1s step-end infinite" }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA buttons */}
        <div className="flex flex-col gap-20 justify-center flex-wrap">
          <div className="flex gap-3 justify-center flex-wrap">
            <a
              href="https://linkedin.com/in/akrosh-mukrambi-24a49b233"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button className="btn-ghost">
                <LinkedInButton size={16} /> Linkedin
              </button>
            </a>
            <button className="btn-ghost" onClick={openWA}>
              <WAIcon size={16} /> WhatsApp
            </button>
            <button
              className="btn-ghost"
              onClick={() =>
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Get in Touch
            </button>
            <button className="btn-ghost" onClick={downloadResume}>
              <DownLoadIcon size={20} /> Resume
            </button>
          </div>
          <div>
            <button
              className="btn-primary"
              onClick={() =>
                document
                  .getElementById("projects")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              View Projects →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
